module.exports = __webpack_public_path__ + "static/media/location_image4.a0110c5a.jpg";